<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/termhub-logo.png" class="header-termhub-logo" alt="Termhub" />
      </div>
    </div>
  </header>

  <div class="signup-body">
    <div>
      <span class="header-text">Sign Up</span>
    </div>
    <div class="login-box">
      <div class="login-form mt-3">
        <div>
          <app-input
            [for]="'usernameInputFC'"
            label="Email"
            placeholder="Enter your email"
            type="email"
            [control]="emailFC"
            [required]="true"
            (keydown.enter)="onSubmit()"
          ></app-input>

          <div *ngIf="email_error">
            <span class="is-invalid">{{ emailErrorMessage }}</span>
            <span [hidden]="!email_error">
              Would you like to <a class="form-link" [routerLink]="'/login'">Log In ></a>? or
              <a class="form-link" [routerLink]="'/password-reset'">Reset your password?</a>
            </span>
          </div>
          <div *ngIf="email_verified_error">
            <span class="is-invalid">{{ emailErrorMessage }}</span>
            <span [hidden]="!email_verified_error">
              Would you like to <a class="form-link" [routerLink]="" (click)="resendVerificationEmail()">Resend verification email</a>?
            </span>
          </div>
        </div>
        <div class="form-group">
          <div class="input-container h-fit-content">
            <app-input
              [for]="'passwordInputFC'"
              label="Password"
              placeholder="Enter your password"
              type="password"
              [control]="passwordFC"
              [required]="true"
              (keydown)="resetPasswordValidation()"
              (keydown.enter)="onSubmit()"
            ></app-input>
            <div class="is-invalid" [hidden]="!password_error">Password is too short.</div>
          </div>
          <app-input
            [for]="'orgInputFC'"
            class="org-input"
            label="Organization"
            info="An organization called &#x2018;Default Org&#x2019; will be created if left empty"
            placeholder="Enter organization (can be edited later)"
            type="text"
            [control]="organizationFC"
            (keydown.enter)="onSubmit()"
          ></app-input>
          <div class="d-flex align-items-center justify-content-center no-wrap mb-2">
            <app-option
              [id]="'acceptCheck'"
              [type]="'checkbox'"
              class="checkbox-height"
              [control]="termsAndPrivacyFC"
              [name]="'acceptCheck'"
              [options]="[
                {
                  label: '',
                  value: true,
                  selected: false,
                  disabled: false,
                },
              ]"
            ></app-option>
            <span>
              I accept our
              <a class="form-link" href="https://www.terminologyhub.com/terms-of-service" target="_blank">Terms of Service</a> and
              <a class="form-link" href="https://www.terminologyhub.com/privacy-policy" target="_blank">Privacy Policy</a></span
            >
          </div>
          <div class="form-group">
            <app-button
              for="signupBtn"
              btnType="login"
              type="submit"
              [disabled]="!termsAndPrivacy || email_error || password_error || !emailFC.value || !passwordFC.value"
              (click)="onSubmit()"
              >Sign Up</app-button
            >

            <div class="is-invalid">{{ submitMessage }}</div>

            <app-button for="googleLoginBtn" btnType="social-login" (click)="googleLogin()">
              <img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4="
                alt="google icon"
                width="20"
              />Sign up with Google
            </app-button>
            <app-button for="microsoftLoginBtn" btnType="social-login" (click)="microsoftLogin()">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeklEQVR4nO3UMQqAMBBE0QUL7+F5LOxyxlSewTvZj/10Q8AI/gfbBpb8pAoAPklt08j4eft5aGSKBRo3IBJK8IgNv1CKhAwJpUjIkFCKhGYnBPzd0m+NjJ+na9XIFAt0bkAklOARG36hFAkZEkqRkCGhFAnNTggA6g0PsZwml5fu+o4AAAAASUVORK5CYII="
                alt="microsoft icon"
                width="24"
              />
              Sign up with Microsoft
            </app-button>
          </div>
        </div>
        <div class="new-account mt-3">
          <div class="signup-link">
            <div>Already have an account? <a class="form-link" [routerLink]="'/login'">Log In ></a></div>
          </div>
        </div>
      </div>

      <ng-template #resultModal let-modal>
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeBtn">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>{{ submitMessage }}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" (click)="modal.close('OK')" id="okBtn">OK</button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="split right tinted-image"></div>
  </div>
</div>
